import React, { useCallback } from "react";
import { useForm } from "react-final-form";
import {
  SaveButton,
  useCreate,
  useNotify,
  FormDataConsumer
} from "react-admin";
import _ from "lodash";
import { isLgLocationById, lgLocationIdParts } from "util/misc";

const SaveWithLocationButton = ({
  handleSubmitWithRedirect,
  record,
  redirect,
  transform = false,
  ...props
}) => {
  const [create, { loading }] = useCreate("comboLocations");
  const notify = useNotify();
  const form = useForm();

  const handleClick = useCallback(
    (formData) => {
      const locationId = _.get(formData, "location");

      if (!isLgLocationById(locationId)) {
        //@todo ugh clean this up
        const locationValue = _.get(locationId, "id", locationId);
        form.change("location", locationValue);
        handleSubmitWithRedirect(redirect);
      } else {
        const { name, stableId } = lgLocationIdParts(locationId);
        const data = { name, stableId };
        create(
          { payload: { data } },
          {
            onSuccess: ({ data }) => {
              form.change("location", data.id);
              handleSubmitWithRedirect(redirect);
            },
            onFailure: ({ error }) => {
              notify(error.message, "error");
            }
          }
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form, create, notify]
  );

  // override handleSubmitWithRedirect with custom logic
  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <SaveButton
          {...props}
          disabled={loading}
          transform={transform}
          handleSubmitWithRedirect={() => handleClick(formData)}
        />
      )}
    </FormDataConsumer>
  );
};

export default SaveWithLocationButton;
